
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Mycelium from "@/components/icons/Mycelium";

const Navbar = () => {
  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur">
      <div className="container flex h-16 items-center">
        <Link to="/" className="flex items-center gap-2">
          <Mycelium className="h-6 w-6 text-eco-500" strokeWidth={1.5} />
          <span className="font-semibold text-lg">Ourcelium</span>
        </Link>
        <nav className="ml-auto flex items-center gap-6">
          <Link to="/" className="text-sm font-medium text-foreground hover:text-eco-500 transition-colors">
            Home
          </Link>
          <Link to="/businesses" className="text-sm font-medium text-foreground hover:text-eco-500 transition-colors">
            Browse
          </Link>
          <Link to="/events" className="text-sm font-medium text-foreground hover:text-eco-500 transition-colors">
            Events
          </Link>
          <Link to="/about" className="text-sm font-medium text-foreground hover:text-eco-500 transition-colors">
            About
          </Link>
          <Link to="/submit">
            <Button variant="outline" className="border-eco-500 text-eco-500 hover:bg-eco-500 hover:text-white">
              Add a Listing
            </Button>
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
